import { Box, Container, Grid, Typography } from '@mui/material';
import TextField from '@mui/material/TextField';

const PhaseAmpField = ({ onChange, value }) => {
    const handleOnChange = (event) => {
        if (event.target.value < 0) {
            event.target.value = 0
        }
        if (isNaN(event.target.value)) {
            event.target.value = 0
        }
        onChange(event.target.value)
    }
    return (
        <Box style={{ paddingTop: 10 }}>
            <TextField
                onChange={handleOnChange}
                label={`Max Phase AMP`}
                name={"max phase amp"}
                id="outlined-size-small"
                size="small"
                value={value}
                inputProps={{ inputMode: 'numeric' }}

            />
        </Box>

    )
}

export default PhaseAmpField
